import React from 'react'

export function renderLeaf (props) {
  let { children } = props

  if (props.leaf.bold) {
    children = (
      <strong>
        {children}
      </strong>
    )
  }

  if (props.leaf.italic) {
    children = (
      <em>
        {children}
      </em>
    )
  }

  if (props.leaf.underline) {
    children = (
      <u>
        {children}
      </u>
    )
  }

  return (
    <span
      {...props.attributes}
      style={{
        paddingLeft: props.leaf.text === ''
          ? '0.1px'
          : undefined
      }}
    >
      {children}
    </span>
  )
}
